import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyDGJ8uMuj4odhT_LuhilbValX4qHAJesbY",
    authDomain: "clone-e8e9b.firebaseapp.com",
    projectId: "clone-e8e9b",
    storageBucket: "clone-e8e9b.appspot.com",
    messagingSenderId: "893531629357",
    appId: "1:893531629357:web:70856f19b152556d8555a4",
    measurementId: "G-LD7PR7C5DZ"
  };

  const firebaseapp = firebase.initializeApp(firebaseConfig);
  const db = firebaseapp.firestore();
  const auth = firebase.auth();

  export {db, auth};